import { ANALYTICS_BASE_PATH, ANALYTICS_BASE_PATH_HP123 } from './screenPaths'
import { ACTIVITY } from './activity'

export const MODALS = {
  WATCH_VIDEO: {
    screenName: 'WatchVideo',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}LandingPage/`
  },
  LEARN_MORE: {
    screenName: 'LearnMore',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}AccountType/`
  },
  SETUP_MODE: {
    screenName: 'SetupMode',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}SetupChecklist/`
  },
  USE_OFFLINE: {
    screenName: 'UseOffline',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}SetupChecklist/`
  },
  PRINTER_NOT_LISTED: {
    screenName: 'PrinterNotListed',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}HpSoftwareTrillium/`
  },
  UNSUPPORTED_OS: {
    screenName: 'UnsupportedOs',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}HpSoftwareTrillium/`
  },
  HP_SMART_FEATURES: {
    screenName: 'HpSmartFeatures',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}HpSoftwareTrillium/`
  },
  HP_SMART_FEATURES_SKYLINE: {
    screenName: 'HpSmartFeatures',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}HpSoftwareSkyline/`
  },
  USE_OFFLINE_INSTALL_SOFTWARE: {
    screenName: 'UseOffline',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}InstallSoftware/`
  },
  SWITCH_TO_MOBILE: {
    screenName: 'SwitchToAmobileDevice',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}InstallSoftware/`
  },
  TROUBLE_INSTALLING: {
    screenName: 'TroublesInstalling',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}InstallSoftware/`
  },
  'power-on': {
    screenName: 'PowerOnModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}PowerOn/`
  },
  'install-ink': {
    screenName: 'InstallInkModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}InstallInk/`
  },
  'load-paper': {
    screenName: 'LoadPaperModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}LoadPaper/`
  },
  'hp-software': {
    screenName: 'HpSoftwareModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}HpSoftwareTrillium/`
  },
  alignment: {
    screenName: 'AlignmentModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}Alignment/`
  },
  purger: {
    screenName: 'PurgerModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}Purger/`
  },
  printheads: {
    screenName: 'PrintheadsModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}Printheads/`
  },
  LANGUAGE_SELECTOR: {
    screenName: 'LanguageSelectorModal',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH_HP123}LandingPage/`
  },
  wheres_product_name: {
    screenName: 'FindProductNameModal##',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH_HP123}SearchPage/`
  },
  scanning_features_notice: {
    screenName: 'AvailableScanningFeatures',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH_HP123}InstallHpEasyStart/`
  }
}
